import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TraceTriggerDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getStateLayerColor
} from "../../../stateLayer/stylesheet";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        alignSelf: "flex-start",
        alignItems: "center",
        flexDirection: "row",
        flexShrink: 1,
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    layer: {
        pointerEvents: "none",
        position: "absolute"
    }
});

export const useStyles = ({
    controlHeights,
    isFocusVisible,
    shapeConfigs,
    isHovered,
    isPressed,
    rowHeight,
    radiuses,
    borders,
    colors,
    spaces
}: TraceTriggerDynamicStyleType) => {
    const layerInset = (rowHeight - controlHeights.small) / 2 + spaces.spacingXxs;

    const styles = {
        layer: {
            backgroundColor: getStateLayerColor({
                overlayColor: "default",
                isHovered,
                isPressed,
                colors
            }),
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            start: -spaces.spacingSm,
            end: -spaces.spacingSm,
            bottom: layerInset,
            top: layerInset
        } as Mutable<ViewStyle>,
        container: {
            minHeight: rowHeight,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.layer, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
